import React, { Component } from 'react';
import { observer, inject } from 'mobx-react';
import { Box, Link, Text, Flex } from 'core/components';
import { Field, InputGroup } from 'core/form';
import GcpAuthenticationPanel from './GcpAuthenticationPanel';
import { FormStep, FormGrid } from '../FormTools';

@inject('$cloudExportWizard')
@observer
class GcpExportConfigFields extends Component {
  renderFlowLogsCopy = () => (
    <>
      <Text as="p" muted>
        Enable VPC flow logs in your account, and set the VPC to export the log to a single “Cloud Pub/Sub topic.” Then
        set the appropriate roles with necessary permissions to permit Kentik to access metadata from the Google Cloud
        account. Finally, enter the project ID and subscription here.
        <br />
        <Link to="https://kb.kentik.com/docs/kentik-for-gcp#enable-vpc-flow-logs" blank>
          Learn more about enabling VPC flow logs in GCP.
        </Link>
        <br />
        <Link to="https://kb.kentik.com/docs/kentik-for-gcp#set-permissions" blank>
          Learn more about setting permissions in GCP.
        </Link>
      </Text>
    </>
  );

  // TODO: When KB article about cloud run logs exists, update link here
  renderCloudRunCopy = () => (
    <>
      <Text as="p" muted>
        Create a new log router sink to export the log to a single &quot;Cloud Pub/Sub topic.&quot;
        <br />
        <Link to="https://kb.kentik.com/docs/kentik-for-gcp" blank>
          Learn more about enabling Cloud Run logging in GCP.
        </Link>
      </Text>
    </>
  );

  renderMetadataCopy = () => (
    <>
      <Text as="p" muted>
        Set the appropriate roles with necessary permissions to permit Kentik to access metadata from the Google Cloud
        account. Then enter the project name here.
        <br />
        <Link to="https://kb.kentik.com/docs/kentik-for-gcp#set-permissions" blank>
          Learn more about setting permissions in GCP.
        </Link>
      </Text>
    </>
  );

  render() {
    const { $cloudExportWizard } = this.props;
    const { isMetadataOnlyEnabled, isFlowLogCollectionEnabled, isGcpCloudRunLogEnabled, isMetricsCollectionEnabled } =
      $cloudExportWizard;
    const showSubscriptionField = isFlowLogCollectionEnabled || isGcpCloudRunLogEnabled;

    const showMetadataOnlyCopy =
      isMetadataOnlyEnabled || (isMetricsCollectionEnabled && !isFlowLogCollectionEnabled && !isGcpCloudRunLogEnabled);

    return (
      <Flex gap={1} data-testid="GcpExportConfigFields">
        <Flex flexDirection="column" gap="1" flex={1} mb={2}>
          <Flex flexDirection="column" gap={1}>
            <FormGrid>
              <FormStep
                stepNumber={1}
                title={
                  <Flex>
                    <Text>API Access</Text>
                  </Flex>
                }
              >
                <GcpAuthenticationPanel />
              </FormStep>

              <FormStep
                stepNumber={2}
                title={
                  <Flex>
                    <Text>GCP Configuration</Text>
                  </Flex>
                }
              >
                {showMetadataOnlyCopy && this.renderMetadataCopy()}
                {isFlowLogCollectionEnabled && this.renderFlowLogsCopy()}
                {isGcpCloudRunLogEnabled && this.renderCloudRunCopy()}

                <Box mt={2} mb={2}>
                  <Field large name="properties.gce_project" placeholder="my-gcp-project" maxWidth={360}>
                    <InputGroup />
                  </Field>
                </Box>

                {showSubscriptionField && (
                  <Box>
                    <Field large name="properties.gce_subscription" placeholder="my-gcp-subscription-id" maxWidth={360}>
                      <InputGroup />
                    </Field>
                  </Box>
                )}
              </FormStep>
            </FormGrid>
          </Flex>
        </Flex>

        <Flex flex={1} flexDirection="column">
          <Flex height={750} flexWrap="wrap" justifyContent="flex-end" />
        </Flex>
      </Flex>
    );
  }
}

export default GcpExportConfigFields;
